<!--
 * @Author: your name
 * @Date: 2022-01-04 17:09:31
 * @LastEditTime: 2022-06-28 11:05:48
 * @LastEditors: zdx 3539255028@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\App.vue
-->
<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enquireScreen from '@/utils/device'
import { getUrlValues } from '@/utils/qs'

export default {
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    let that = this
    const { app } = getUrlValues()
    if (app) {
      sessionStorage.setItem('appCode', app)
    }
    enquireScreen((deviceType) => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      } else if (deviceType === 1) {
        // mobile
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
      }
    })
  },
}
</script>
<style>
@import '//at.alicdn.com/t/font_2699767_bxefv5xqb0k.css';
@import '//at.alicdn.com/t/font_3124122_u0q50gylmy.css';
#app {
  height: 100%;
}
</style>
